import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { LojaRequest } from 'pages/cadastro/loja/types';

export function useQueryDadosBasicos() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<LojaRequest>({
        queryKey: ['loja', id],
        queryFn: () => requestListagem({ url: `/gestao/loja/${id}` }).then((res) => res.data.data),
        enabled: !!id,
    });
}
